import { connect } from 'react-redux';
import { pushUnsubscribeModal } from '../../Tier/redux/consumer/actions';
import { isConsumerReduxReady, isMatureFilterOverridden } from '../../Tier/redux/consumer/selectors';
const mapStateToProps = (state, ownProps)=>({
        reduxReady: isConsumerReduxReady(state),
        matureFilterOverridden: isMatureFilterOverridden(state, ownProps.tier.deviationId)
    });
const mapDispatchToProps = {
    onUnsubscribe: pushUnsubscribeModal
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=SubscribeButton.container.js.map